import cuestionarioService from '../services/cuestionario.js';

export const useCuestionario = () => {

    const getCuestionarioActual = (usuario) => cuestionarioService.getActual(usuario);

    const getCuestionarosHistoricos = (usuario) => cuestionarioService.getHistorico(usuario);

    const finalizarCuestionario = (usuario) => cuestionarioService.finalizar(usuario);

    const getCuestionarioReport = (usuario, idCuestionario, chartImage) => cuestionarioService.getReport(usuario, idCuestionario, chartImage);

    const getCuestionarioReportParcial = (usuario, idCuestionario, chartImage) => cuestionarioService.getReportParcial(usuario, idCuestionario, chartImage);

    const getCuestionarioReportEje = (usuario, idCuestionario, idEje) => cuestionarioService.getReportEje(usuario, idCuestionario, idEje);

    const getEjesCuestionario = (usuario) => cuestionarioService.getEjes(usuario);

    const nuevoConPerfilEmpresarial = (usuario, newProfileData) => cuestionarioService.nuevoConPerfilEmpresarial(usuario, newProfileData);

    const anularEje = (usuario, idEje) => cuestionarioService.anularEje(usuario, idEje);

    const activarEje = (usuario, idEje) => cuestionarioService.activarEje(usuario, idEje);


    return { getCuestionarioActual, getCuestionarosHistoricos, finalizarCuestionario, getCuestionarioReport, getEjesCuestionario, nuevoConPerfilEmpresarial, getCuestionarioReportEje, anularEje, activarEje, getCuestionarioReportParcial};
}